import { ContestInterestedFreelancerAjax } from './contest-interested-freelancers.backend-model';
import { ContestInterestedFreelancer } from './contest-interested-freelancers.model';

export function transformContestInterestedFreelancer(
  contestInterestedFreelancer: ContestInterestedFreelancerAjax,
): ContestInterestedFreelancer {
  return {
    id: contestInterestedFreelancer.id,
    contestId: contestInterestedFreelancer.contest_id,
    publicName: contestInterestedFreelancer.public_name,
    profileUrl: `/u/${contestInterestedFreelancer.username}`,
    createDate: contestInterestedFreelancer.create_date * 1000,
  };
}
